import React from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {authenticationActions} from "../../actions/index";

export class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hasError: false
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true});
    }

    render() {
        if ( this.state.hasError ) {
            return (
                <div data-test="component-errorBoundary" className='animate__animated animate__fadeIn'>
                    <div id='notfound'>
                        <div className='notfound'>
                            <div className='notfound-404'>
                                <h1>Oops!</h1>
                                <div id='subtitle'>Qualcosa è andato storto</div>
                            </div>
                            <Link to='/login' onClick={() => {
                                this.props.initAuth();
                                sessionStorage.clear();
                                this.setState(prevState => ({ hasError: !prevState.hasError}))
                            }}>
                                <div id='similLink' className='shadow'>Go TO Homepage</div>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.props.children;
        }
    }
}

const mapDispatchToProps = dispatch => {
    return {
        initAuth: () => dispatch(authenticationActions.initAuth()),
    }
};

export default connect(null, mapDispatchToProps)(ErrorBoundary);
